import PropTypes from "prop-types";
import React from "react";
import classes from "./CGV.module.css";

export const CGV = ({ translate }) =>
  <div className={classes.pageContainer}>
    <h2>Conditions générales de vente et utilisation</h2>
    <p>
      Les services objet du site https://bluegreen.extraclub.fr, sont proposés par la société BLUE GREEN, SAS au capital
      de 187 083 Euros, ayant son siège social, PARC SAINT CHRISTOPHE - 10 avenue de l'entreprise - Le Magellan 3 -
      niveau 2 - 95862 CERGY PONTOISE, France, immatriculée au Registre du Commerce et des Sociétés de Pontoise, sous le
      numéro RCS B 344 206 511, ayant pour numéro de TVA intracommunautaire FR31 344 206 511.{" "}
    </p>

    <h3>1°) Définitions</h3>
    <p>
      Client(s) : Désigne les personnes, souhaitant s'inscrire, acheter et créditer sur leur compte client
      Bluegreen/Extraclub des unités dématérialisées via le site https://bluegreen.extraclub.fr. Ces unités peuvent être
      échangées, sur les Golfs, contre des produits et services proposés par ceux-ci. Tout client reconnaît avoir pris
      connaissance des présentes conditions de vente, en accepter les termes avant passation de sa commande, et avoir la
      capacité de contracter avec Blue Green, être majeur, et ne pas être sous tutelle ou curatelle.
    </p>
    <p>
      Golfs : Désigne les golfs exploités et gérés par Blue Green, équipés du système de cartes et gestion de compte
      client Bluegreen/Extraclub proposant des services et prestations golfiques en échange d’unité dématérialisées
      proposées au rechargement sur le site https://bluegreen.extraclub.fr. La liste de ces Golfs est consultable sur le
      site www.bluegreen.com.
    </p>
    <p>
      Site: désigne le site https://bluegreen.extraclub.fr créé et hébergé par la société Stadline/Extraclub pour
      proposer les services de ventes et rechargements d’unités dématérialisées.
    </p>

    <h3>2°) Objet des Conditions générales</h3>
    <p>
      Les présentes Conditions Générales ont pour objet de définir les obligations de Blue Green et du Client, ainsi que
      les conditions de fourniture des Services par les golfs aux Clients en échanges des unités dématérialisées
      créditées sur leur compte.
    </p>

    <h3>3°) Services</h3>
    <p>
      Blue Green s'efforce d'illustrer avec précision et réalisme les services qui vous sont proposés au travers de la
      page. Il est toutefois précisé que ces photos et illustrations associées aux descriptifs de Services demeurent
      illustratives et ne sont pas opposables à Blue Green.
    </p>
    <p>
      Les Services des Golfs consultables sur la page pourront exceptionnellement être supprimés, annulés ou amendés
      sans qu’aucune justification par la société Blue Green ne soit nécessaire notamment en cas d'évènements
      climatiques ou cas de force majeure. Ces annulations ne sauraient engager la responsabilité de Blue Green ni
      entraîner un quelconque dédommagement.
    </p>

    <h3>4°) Acceptation des Conditions Générales</h3>
    <p>
      Chaque Client reconnaît avoir pris connaissance des présentes Conditions Générales préalablement à toute commande
      et en accepter les termes et conditions. Il valide à cet effet la case à cocher préalablement à sa commande,
      laquelle implique son acceptation sans réserve des présentes.
    </p>
    <p>
      Les Conditions Générales s'appliquent à l'exclusion de tout autre document, clause ou indication contraire, sous
      réserve toutefois des dispositions du règlement intérieur et des propres conditions générales des Golfs
      partenaires auxquels les présentes ne dérogent pas.
    </p>
    <p>
      Les Conditions Générales applicables sont celles en vigueur sur le Site à la date de votre commande. Vous pouvez à
      cette occasion sauvegarder ou éditer celles-ci. Vous pouvez également en obtenir copie sur simple demande écrite
      adressée au siège social de la société Blue Green.{" "}
    </p>
    <p>
      Compte tenu notamment des extensions et améliorations possibles du service, Blue Green se réserve la possibilité
      d'adapter, de réviser ou de modifier à tout moment le champ des prestations offertes aux termes des présentes. Les
      conditions générales peuvent dans ce contexte être modifiées ou révisées à tout moment. Ces modifications seront
      applicables aux rechargements d’unités et services souscrits postérieurement à cette modification.
    </p>

    <h3>5°) Offres distribuées sur le Site</h3>
    <p>Sur le Site sont proposés :</p>
    <ul>
      <li>Achat de recharges d’unités dématérialisées.</li>
    </ul>
    <p>Usage sur les Golfs de ces unités</p>
    <ul>
      <li>Distribution de seaux de balles de practice pour l’entraînement du Client.</li>
    </ul>

    <h3>6°) Commande de recharge d’unités dématérialisées</h3>
    <p>
      Prérequis : le Client devra avoir préalablement créé son compte client auprès de l’accueil de l’un des Golfs. Une
      carte personnelle plastifiée avec puce RFID contenant une information qui la lie à son compte client lui sera
      remise.
    </p>
    <p>
      Les achats effectués par le Client se font par l'intermédiaire du système d'achat accessible en ligne sur le Site
      à l'exclusion de tout autre moyen de communication. Aucun achat ne pourra être effectué notamment par téléphone,
      courrier, courriel ou télécopie. La commande est précédée d'une acceptation des présentes conditions générales.
    </p>
    <p>
      Le client fait son choix d’unité et de leur quantité parmi les package de rechargement proposés. Le ou les Golfs
      d’utilisation des unités et leur date d’expiration seront précisés et rappelés dans la confirmation de commande.
    </p>
    <p>
      Le Client atteste de la véracité et de l'exactitude des informations transmises lors de sa commande et nécessaire
      au traitement de celles-ci. Le Client se doit de vérifier la véracité, l'exhaustivité et la conformité des
      renseignements qu'il fournit à Blue Green pour les besoins de sa commande. Blue Green ne saurait être tenu pour
      responsable des conséquences éventuellement dommageables pour le Client d'une fausse déclaration, impossibilité
      pour le Client de justifier de son statut auprès des Golfs ou d'erreurs de saisie. Dans ce contexte, tous les
      frais engagés seront et resteront à la charge du Client.
    </p>
    <p>
      Ces informations sont nécessaires à Blue Green pour traiter votre demande. Elles sont enregistrées dans notre
      fichier de clients et peuvent donner lieu à l'exercice du droit d'accès et de rectification aux conditions
      définies aux présentes.
    </p>
    <p>
      L'acceptation de la commande par Blue Green est matérialisée par l'envoi, à l'adresse électronique indiquée par le
      Client, de la confirmation de commande, ou à défaut, lors du paiement en ligne par carte bancaire. Votre carte
      bancaire est immédiatement débitée.
    </p>
    <p>
      Dans l'éventualité où Blue Green se trouvait contraint de par un événement extérieur d'apporter une modification
      ou d'annuler la commande après que celle-ci ait fait l'objet d'une confirmation, Blue Green en informera le Client
      par mail adressé à l'adresse électronique indiquée par celui-ci lors de sa commande. Les sommes versées seront
      intégralement remboursées au Client.
    </p>
    <p>
      Tout Service non consommé, interrompu ou abrégé du fait du Client ne saurait donner à un quelconque droit à
      remboursement de la part de Blue Green.
    </p>

    <h3>7°) Prix et validité des offres</h3>
    <p>
      Les prix sont indiqués en Euros, TVA comprise au taux en vigueur au jour de la passation de commande. Ils
      comprennent la réalisation des Services décrits dans la commande à l'exclusion de toutes prestations
      complémentaires ou non expressément listés dans le descriptif de l'offre sur le Site.
    </p>
    <p>
      Les offres et prix sont valables tant qu'ils demeurent en ligne sur le Site et jusqu'à épuisement le cas échéant,
      et peuvent varier en temps réel, Blue Green se réservant le droit de modifier ses prix à tout moment et sans
      préavis.
    </p>
    <p>
      Le mail de confirmation de la commande indiquera le prix TTC. En fin de processus d’achat un lien sur le site
      permettra le téléchargement de de la facture mentionnant le prix TTC et le montant de la TVA. Un duplicata pourra
      être demandé aux Golfs.
    </p>

    <h3>8°) Remise et programme de fidélité</h3>
    <p>
      Blue Green propose pour les clients concernés (abonnés et détenteur Blue Green Card Gold), dans les conditions
      fixés dans sa politique commerciale, des remises sur les rechargements d’unité. Ses remises ne sont pas
      applicables sur le Site, et ne pourront donc être appliquées que lors de rechargements faits directement sur les
      Golfs.
    </p>
    <p>
      Pour les clients abonnés Blue Green, les recharges d’unités practice effectuées en ligne ne donneront lieu à aucun
      cumul de points sur leur programme de fidélité Blue Green. Le cumul de points sur le programme de fidélité du
      client abonné ne pourra se faire que pour les rechargements effectués sur les Golfs.{" "}
    </p>

    <h3>9°) Modalités de paiement</h3>
    <p>Le prix est exigible à la commande.</p>
    <p>
      Les paiements seront effectués par carte bancaire (VISA, EUROCARD, MASTERCARD). Ils seront réalisés par le biais
      du système sécurisé de notre partenaire bancaire LCL dont le siège social est situé 18 rue de la république 69002
      LYON CEDEX. Blue Green se réserve le droit de refuser d'honorer une commande émanant d'un Client qui n'aurait pas
      réglé totalement ou partiellement une commande précédente ou avec lequel un litige de paiement serait en cours de
      résolution.
    </p>

    <h3>10°) Echanges des unités contre des prestations golfiques</h3>
    <h4>10.1 Accès aux Golf</h4>
    <p>
      Le Client devra, à tout moment, se conformer au règlement intérieur en vigueur dans les Golfs objet de sa commande
      et dans lesquels il se trouve (dont notamment licence et tenue vestimentaire).{" "}
    </p>

    <h4>10.2 Echanges d’unité pour la distribution de seaux de balles de practice</h4>
    <p>
      Les Golfs sont équipés d’un système commun de lecteur de carte RFID et d’un écran fixé sur les systèmes de
      distribution des balles. L’échange des unités contre les seaux de balles se fait directement au distributeur. Un
      premier passage de la carte affichera le solde d’unité sur le compte du client. Un second passage déclenchera la
      consommation du nombre d’unité sur le compte nécessaire à la distribution des balles. Le nombre d’unité consommé
      pour la distribution d’un seau se fera, sauf périodes de promotion ou conditions particulières, selon la
      tarification nationale en vigueur le jour de l’utilisation et consultable à l’accueil des Golfs ou sur le site
      www.bluegreen.com.
    </p>
    <p>
      Le système consommera/échangera automatiquement les unités du compte présentant la date d’expiration la plus
      proche du jour de l’utilisation.
    </p>

    <h3>11°) Empêchement lié à un cas de Force majeure</h3>
    <p>
      La force majeure s'entend de tout évènement extérieur aux parties présentant un caractère à la fois imprévisible
      et insurmontable qui empêche soit le client, soit Blue Green, soit les Golfs d'assurer tout ou partie des
      obligations souscrites. Il en est notamment ainsi en cas de grève, insurrection, émeute, prohibitions édictées par
      les autorités gouvernementales ou publiques. Il est expressément convenu que la force majeure suspend, pour les
      parties, l'exécution de leurs obligations réciproques et que chaque partie supporte la charge des frais qui en
      découlent.
    </p>

    <h3>12°) Droit de rétractation</h3>
    <p>
      Conformément aux dispositions de l'article L 121-20 du code de la Consommation, en cas de souscription au Service
      via l'utilisation d'une ou plusieurs techniques de commercialisation à distance, sans la présence physique
      simultanée des parties, le Client dispose d'un délai de 7 jours francs pour exercer son droit de rétractation sans
      avoir à justifier de motif ni à payer de pénalités. Ce délai de 7 jours francs court à compter de l'acceptation de
      la commande par Blue Green. Si ce délai expire un samedi, un dimanche ou un jour férié ou chômé, il est prorogé
      jusqu'au premier jour ouvré suivant.
    </p>
    <p>
      Ce droit de rétractation s'exerce par le Client par l'envoi d'un simple e-mail à l'adresse bluegreen@bluegreen.com
      en mentionnant sa référence Client. Dans ce cas, le Client sera remboursé, dans un délai maximum de trente (30)
      jours suivant la date à laquelle il aura exercé son droit de rétractation, du prix total de sa commande facturé et
      éventuellement déjà encaissé par Blue Green. Toute rétractation retournée à une adresse différente de celle
      communiquée, ne sera pas traitée et donc non remboursée.
    </p>
    <p>
      Article L121-20-2 (inséré par Ordonnance n° 2001-741 du 23 août 2001 art. 5 et art. 12 Journal Officiel du 25 août
      2001) Le Client est averti de ce que le droit de rétractation ne peut être exercé, pour les contrats de fourniture
      de services dont l'exécution a commencé, avec l'accord du consommateur, avant la fin du délai de sept jours
      francs.
    </p>
    <p>
      Article L121-20-4 du Code de la consommation. De même, le Client est averti de ce que, lorsque le Service s'entend
      d'une prestation touristique, telle un séjour, les dispositions légales relatives au droit de rétractation en cas
      de vente à distance prévues par le Code de la consommation ne sont pas applicables. Le Client ne bénéficie d'aucun
      droit de rétractation dans ce cas.
    </p>

    <h3>13°) Informations nominatives</h3>
    <p>
      Conformément à la loi n° 78-17 du 6 janvier 1978, relative à l'informatique, aux fichiers et aux libertés vous
      pouvez à tout moment accéder aux informations personnelles vous concernant et détenues par la société Blue Green,
      demander leur modification ou leur suppression. Pour cela, il suffit de nous en faire la demande en ligne à
      l'adresse mail comm2@bluegreen.com ou par courrier en nous indiquant vos nom, prénom, adresse et votre référence
      client à l'adresse suivante : Bluegreen SAS – Données personnelles, 10 Avenue de l’entreprise – magellan 3 niveau
      2 – 95862 CERGY-PONTOISE. Pour des besoins de sécurité, il pourra à cette occasion vous être demandé copie de
      votre pièce d'identité.
    </p>
    <p>
      Les informations transmises lors de votre commande sont nécessaires à Blue Green pour le bon traitement de votre
      demande. Ces informations ont pour seuls destinataires Blue Green et les Golfs concernés par votre commande. En
      acceptant les présentes conditions générales vous acceptez que nous communiquions ces informations dans le cadre
      d'une demande de réservation.
    </p>
    <p>
      Elles sont enregistrées dans notre fichier de clients et peuvent donner lieu à l'exercice du droit d'accès et de
      rectification aux conditions définies ci-dessus. Vous êtes susceptibles de recevoir des offres commerciales de
      notre société pour des produits et services analogues à ceux que vous avez commandés. Si vous ne le souhaitez pas,
      cochez la case correspondante du formulaire de collecte d'information.
    </p>
    <p>
      Blue Green informe le client que ces informations seront utilisées par ses services internes et/ou ceux de ses
      filiales pour renforcer et personnaliser la communication notamment par l'envoi de newsletters et d'offres
      spéciales (bon plans, actualité des golfs, jeux, etc…).
    </p>
    <p>
      Par ailleurs, Blue Green rappelle que si le client venait à changer d'avis et ne souhaitait plus recevoir une
      certaine catégorie d'emails, il pourrait à tout moment le faire savoir en envoyant un simple mail à l’adresse
      bluegreen@bluegreen.com.
    </p>

    <h3>14°) Responsabilité</h3>
    <p>
      14.1 Blue Green assume une obligation de mise en œuvre de moyens au regard des services proposés. A cet effet,
      Blue Green s'efforce de rendre son Site disponible en permanence. Cependant, pour des raisons de maintenance, de
      sécurité ou d'incident sur les réseaux de télécommunication, l'accès est susceptible d'être temporairement
      suspendu ou interrompu pour des raisons de maintenance.
    </p>
    <p>
      Cette interruption fera l'objet d'un avertissement figurant sur la page d'accueil du Site ou par tout autre
      procédé. Une telle interruption, suspension ou fermeture provisoire du Site ne peut en aucun cas engager la
      responsabilité de Blue Green et n'ouvre droit à aucune indemnité.
    </p>
    <p>
      La sécurité du fonctionnement des réseaux de télécommunication ne peut être garantie par Blue Green qui ne peut
      être tenu pour responsable en ce qui concerne le transport des informations ou des conséquences résultant d'un
      défaut de sécurité ou de fiabilité du terminal de connexion utilisé par le Client. Blue Green ne peut être tenu
      responsable de toutes les conséquences qui résulteraient d'une erreur de transmission ou de manipulation de la
      part du Client.
    </p>
    <p>
      Les présentes conditions générales ne dérogent pas aux dispositions du règlement intérieur et des propres
      conditions générales des Golfs, lesquels s'appliquent, ce que reconnaît le Client à la réalisation des services
      souscrits sur le site.
    </p>
    <p>
      14.2 Les Services proposés sur le Site sont conformes à la législation française en vigueur et aux normes
      applicables en France. Les photographies, textes, graphismes, informations et caractéristiques reproduits et
      illustrant les Services ne sont pas contractuels. La responsabilité de Blue Green ne saurait être engagée en cas
      d'erreur, modification ou omission quelconque dans l'une de ces photographies, textes, graphismes, informations ou
      caractéristiques.
    </p>
    <p>
      14.3 Des liens hypertextes peuvent renvoyer vers d'autres sites internet que le Site. Blue Green dégage toute
      responsabilité dans le cas où le contenu de ces sites contreviendrait aux dispositions légales et règlementaires
      en vigueur.
    </p>
    <p>
      14.4 La responsabilité de Blue Green quelle qu'en soit la cause ou la forme de l'action ne saurait être supérieure
      à celle du montant global de la prestation réglée par le Client.
    </p>

    <h3>15°) Conditions d'accès au site Internet</h3>
    <p>Les mentions légales de ce Site figurent sous le lien suivant.</p>
    <p>
      Tous les éléments constitutifs du Site (notamment les noms de domaine, sa structure générale, l'arborescence du
      Site, les textes, les marques déposées, noms de domaine, les textes, graphismes, charte graphique, iconographie,
      logos, sons, photos, animations, bases de données, ainsi que le Site en tant que tel) sont, à l'exclusion des
      éléments émanant de nos partenaires, la propriété de Blue Green ou font l'objet d'une autorisation légale
      d'utilisation.
    </p>
    <p>
      La protection du Site relève par conséquent, des législations nationales et internationales relatives au droit de
      la propriété intellectuelle dont notamment celles concernant le droit des marques et le droit d'auteur. Dès lors,
      toute reproduction ou représentation ou rediffusion ou utilisation ou distribution ou copie ou dénaturation ou
      transmission ou adaptation ou décompilation ou traduction, en tout ou partie, sur tout support électronique ou
      non, présent ou futur, sont interdites sauf autorisation écrite, exprès et préalable de Blue Green.
    </p>
    <p>
      De même, aucun droit ou licence ne saurait être attribué sur l'un quelconque des éléments du Site sans
      l'autorisation écrite et préalable de Blue Green ou du tiers, détenteur des droits sur ces éléments.
    </p>
    <p>
      La violation des droits dévolus à Blue Green sont susceptible de constituer un acte de contrefaçon, une faute
      civile, une atteinte au droit à l'image et aux droits des personnes, engageant les responsabilités civile et
      pénale de tout contrevenant. Il en va ainsi notamment des images ou photographies de personnes ou de lieux
      figurant sur le Site, propriété de Blue Green et/ou utilisées par Blue Green avec l'accord des titulaires des
      droits.
    </p>
    <p>
      De même, les bases de données d'informations sont protégées par la loi, de sorte que toute extraction ou tentative
      d'extraction quantitativement ou qualitativement substantielle, fut-elle totale ou partielle, est susceptible
      d'engager les responsabilités civile et pénale de tout contrevenant.
    </p>

    <h3>16°) Dispositions générales</h3>
    <p>
      Si une ou plusieurs stipulations des Conditions Générales sont tenues comme étant non valides ou déclarées telles
      en application d'une Loi, d'un règlement ou à la suite d'une décision devenue définitive d'une juridiction, les
      autres stipulations des Conditions Générales garderont toute leur force et leur portée.
    </p>
    <p>
      Les enregistrements conservés dans le système informatique de Blue Green constituent la preuve des opérations
      effectuées par le client et ont valeur de preuve des commandes passées et des informations données.
    </p>

    <h3>17°) Droit applicable et litiges</h3>
    <p>
      Les présentes Conditions Générales sont soumises au droit français. Tout litige découlant de ces Conditions
      Générales sera de la compétence exclusive des tribunaux Français.
    </p>

    <p>
      <strong>CONDITIONS GÉNÉRALES DE VENTE</strong>
      <br />
      Blue Green – S.A.S. au capital de 183 083 € – R.C.S. Pontoise B 344 206 511<br />
      TVA intracommunautaire FR31 344 206 511
    </p>
  </div>;

CGV.propTypes = {
  translate: PropTypes.func.isRequired
};

export default CGV;



// WEBPACK FOOTER //
// ./src/app/components/CGV/CGV.js